const messages = {
    en: {
        calendar: {
            validation: {
                mustBeGreaterThanFrom: 'Must be greather than from',
                wrongHourFormat: 'Wrong format. Format expected HH:MM'
            },
            calendar: {
                title: 'Calendar management',
                subtitle: 'View, search, create, edit and delete Calendar',
                creating: 'Creating Calendar',
                editing: 'Editing Calendar',
                deleting: 'Deleting Calendar',
                showing: 'Showing Calendar',
                calendarSchedule: 'Calendar schedule',
                menu: {
                    calendar: 'Calendar'
                },
                days: {
                    monday: 'Monday',
                    thursday: 'Thursday',
                    wednesday: 'Wednesday',
                    tuesday: 'Tuesday',
                    friday: 'Friday',
                    saturday: 'Saturday',
                    sunday: 'Sunday'
                },
                labels: {
                    name: 'Name',
                    description: 'Description',
                    identifier: 'Identifier',
                    user: 'User',
                    priority: 'Priority',
                    dayOfWeek: 'Day of Week',
                    dayName: 'Day name',
                    from: 'From',
                    to: ' To',
                    links: 'Links'
                },

            }
        }
    },
    es: {
        calendar: {
            validation: {
                mustBeGreaterThanFrom: 'Debe ser mayor a desde',
                wrongHourFormat: 'Formato incorrecto. Formato esperado: HH:MM'
            },
            calendar: {
                title: 'Administración de Calendario',
                subtitle: 'Ver, buscar, crear, editar, y borrar Calendario',
                creating: 'Creando Calendar',
                editing: 'Modificando Calendario',
                deleting: 'Eliminando Calendario',
                showing: 'Detalles de Calendario',
                calendarSchedule: 'Horarios de calendario',
                menu: {
                    calendar: 'Calendario'
                },
                days: {
                    monday: 'Lunes',
                    thursday: 'Martes',
                    wednesday: 'Miercoles',
                    tuesday: 'Jueves',
                    friday: 'Viernes',
                    saturday: 'Sabado',
                    sunday: 'Domingo'
                },
                labels: {
                    name: 'Nombre',
                    description: 'Descripción',
                    identifier: 'Identificador',
                    user: 'Usuario',
                    priority: 'Prioridad',
                    dayOfWeek: 'Dia de la semana',
                    dayName: 'Nombre del dia',
                    from: 'Desde',
                    to: ' Hasta',
                    links: 'Links'
                },

            }
        }
    },
    pt: {
        calendar: {
            validation: {
                mustBeGreaterThanFrom: 'Debe ser mayor a desde',
                wrongHourFormat: 'Formato incorrecto. Formato esperado: HH:MM'
            },
            calendar: {
                title: 'Administração de Calendar',
                subtitle: 'Ver, buscar, criar, editar e usar Calendar',
                creating: 'Criando Calendar',
                editing: 'Edição Calendar',
                deleting: 'Apagando Calendar',
                showing: 'Detalhes do Calendar',
                calendarSchedule: 'Horarios de calendario',
                menu: {
                    calendar: 'Calendário'
                },
                days: {
                    monday: 'Segunda-feira',
                    thursday: 'Quinta-feira',
                    wednesday: 'Quarta-feira',
                    tuesday: 'Terça-feira',
                    friday: 'Sexta-feira',
                    saturday: 'Sábado',
                    sunday: 'Domigo'
                },
                labels: {
                    name: 'Nome',
                    description: 'Descrição',
                    identifier: 'Identificador',
                    user: 'Usuario',
                    priority: 'Prioridade',
                    dayOfWeek: 'Day of Week',
                    dayName: 'Day name',
                    from: 'From',
                    to: ' To',
                    links: 'Links'
                },

            }
        }
    }
}

export default messages
